import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, ReactElement } from 'react';

import { AudioPlayerTrackCaption, PlayIconType, TPlayIconTheme } from '@gem/ui-kit';

import { AudioState } from 'APP/main/components/AudioState/AudioState';

import { VoiceHistogram } from '../VoiceHistogram/VoiceHistogram';
import { useVoicePresenter } from './VoicePlayer.presenter';
import styles from './VoicePlayer.styles.m.css';

interface IVoicePlayerProps {
  src: string;
  groupId: string;
  messageId: string;
  payloadId: string;
  clientUuid: string;
  isLoading: boolean;
  duration: string;
  size: number;
  histogram: string;
  LoadingComponent: () => ReactElement;
  theme?: TPlayIconTheme;
}

export const VoicePlayer: FC<IVoicePlayerProps> = observer((props) => {
  const {
    groupId,
    messageId,
    payloadId,
    clientUuid,
    src,
    duration,
    size,
    histogram,
    isLoading,
    LoadingComponent,
    theme = '0',
  } = props;

  const {
    isPlaying,
    isActiveTrack,
    progress,
    progressPercentage,
    formattedDuration,
    onTogglePlay,
    onChangeProgress,
  } = useVoicePresenter({
    groupId,
    messageId,
    payloadId,
    clientUuid,
    duration,
    isLoading,
  });

  if (!src) {
    return null;
  }

  return (
    <div className={classNames(styles.audio, styles[`voice-player-theme-${theme}`])}>
      {isLoading ? (
        <LoadingComponent />
      ) : (
        <div className={styles.playContainer}>
          <AudioState
            groupId={groupId}
            messageId={messageId}
            payloadId={payloadId}
            iconType={isPlaying ? PlayIconType.Pause : PlayIconType.Play}
            onClick={onTogglePlay}
            theme={theme}
          />
        </div>
      )}
      <div className={styles.controlsContainer}>
        <VoiceHistogram
          histogram={histogram}
          progress={progressPercentage}
          onChangeProgress={onChangeProgress}
          theme={theme === 'chat' ? theme : undefined}
        />

        <AudioPlayerTrackCaption
          className={styles.time}
          isPlaying={isActiveTrack}
          duration={formattedDuration}
          progress={progress}
          size={size}
        />
      </div>
    </div>
  );
});
